import React from 'react'
import Grid from '@material-ui/core/Grid'
import Divider from '@material-ui/core/Divider'
import Box from '@material-ui/core/Box'
import IconButton from '@material-ui/core/IconButton'
import { get } from 'lodash'
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt'

export default function CustomizedTables({ list, actions = [] }) {
  return (
    <Box overflow="auto" whiteSpace="nowrap">
      <Box mt={4} minWidth="700px">
        {list.map((item, key) => (
          <div key={key}>
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <Box mb={1}>{get(item, 'mall.name')}</Box>
                <Box>
                  Pharmacy • {get(item, 'mall.pharmacy_license.type')} {get(item, 'mall.pharmacy_license.number')}/
                  {get(item, 'mall.pharmacy_license.year')}
                </Box>
              </Grid>
              <Grid item xs={4}>
                <Box mb={1}>
                  {get(item, 'first_name')} {get(item, 'last_name')}
                </Box>
                <Box>{get(item, 'mobile')}</Box>
              </Grid>
              <Grid item xs={4}>
                <Box mb={1}>
                  {get(item, 'mall.shipping_address.line1')} {get(item, 'mall.shipping_address.sub_district')}
                </Box>
                <Box>
                  {get(item, 'mall.shipping_address.district')} {get(item, 'mall.shipping_address.province')}{' '}
                  {get(item, 'mall.shipping_address.postal_code')}
                </Box>
              </Grid>
              <Grid item xs={1}>
                {actions[0] && (
                  <IconButton onClick={() => actions[0](item)}>
                    <ArrowRightAltIcon />
                  </IconButton>
                )}
              </Grid>
            </Grid>
            <Box mt={2} mb={2}>
              <Divider />
            </Box>
          </div>
        ))}
      </Box>
    </Box>
  )
}
